module.exports = "./assets/images/avatar-12.svg";